export default "__VITE_ASSET__DhpqoFJ$__"